import { Injectable } from '@angular/core';
import { DocumentEnum } from './DocumentEnum';
import { RestAPIService } from '../restAPI/rest-api.service';
import { Validators } from '@angular/forms';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DocumentsService {
  private readonly getDocument = '/api/document';
  private readonly getAllCloudStoragePath = '/doctype';
  private documentRefreshSource = new Subject<void>();
  documentRefreshed$ = this.documentRefreshSource.asObservable();
  constructor(private restApiService: RestAPIService) {}

  FieldMapINDIA: Record<
    string,
    {
      label: string;
      name: string;
      type: string;
      inputMode: string;
      validators: any[];
      errorMessage?: string;
    }[]
  > = {
    AADHAAR: [
      {
        label: 'Aadhaar Number',
        name: 'documentNumber',
         type: 'text',
        inputMode: 'numeric',
        validators: [Validators.required,Validators.pattern(/^\d{4}-\d{4}-\d{4}$/)],
        errorMessage: 'Enter a valid Aadhaar number (1234-5678-9012).',
      },
      {
        label: 'Name on Aadhaar',
        name: 'name_on_document',
        type: 'text',
        validators: [Validators.required,Validators.pattern(/^[A-Za-z ]{2,50}$/)],
        errorMessage: 'Name should not contain any special characters (2–50 characters).',
        inputMode: 'text',
      },
    ],
    PAN: [
      {
        label: 'PAN Number',
        name: 'documentNumber',
        type: 'text',
        validators: [Validators.required, Validators.pattern(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/)],
        inputMode: 'text',
        errorMessage: 'Enter a valid PAN number (ABCDE1234F).',
      },
      {
        label: 'Name on PAN',
        name: 'name_on_document',
        type: 'text',
        validators: [Validators.required,Validators.pattern(/^[A-Za-z ]{2,50}$/)],
        errorMessage: 'Name should not contain any special characters (2–50 characters).',
        inputMode: 'text',
      },
    ],
    VOTER_ID: [
      {
        label: 'Voter ID',
        name: 'documentNumber',
        type: 'text',
        validators: [Validators.required, Validators.pattern(/^[A-Z]{3}[0-9]{7}$/)],
        inputMode: 'text',
        errorMessage: 'Enter a valid Voter ID (ABC1234567).',
      },
      {
        label: 'Name on Voter ID',
        name: 'name_on_document',
        type: 'text',
        validators: [Validators.required,Validators.pattern(/^[A-Za-z ]{2,50}$/)],
        errorMessage: 'Name should not contain any special characters (2–50 characters).',
        inputMode: 'text',
      },
    ],
    ADDRESS_PROOF: [
      {
        label: 'Address proof',
        name: 'documentProofType',
        type: 'select',
        validators: [Validators.required],
        inputMode: 'text',
        errorMessage: 'Address proof type is required.',
      },
      {
        label: 'Document number',
        name: 'documentNumber',
        type: 'text',
        validators: [Validators.required],
        inputMode: 'text',
        errorMessage: 'Document number is required.',
      },
      {
        label: 'Name on Document',
        name: 'name_on_document',
        type: 'text',
        validators: [Validators.required,Validators.pattern(/^[A-Za-z ]{2,50}$/)],
        errorMessage: 'Name should not contain any special characters (2–50 characters).',
        inputMode: 'text',
      },
    ],
   
  };

  FieldMapUSA: Record<
    string,
    {
      label: string;
      name: string;
      type: string;
      inputMode: string;
      validators: any[];
      errorMessage?: string;
    }[]
  > = {
    VOTER_ID: [
      {
        label: 'Voter ID',
        name: 'documentNumber',
        type: 'text',
        validators: [Validators.required],
        inputMode: 'text',
      },
    ],
    ADDRESS_PROOF: [
      {
        label: 'Document number',
        name: 'documentNumber',
        type: 'text',
        validators: [Validators.required],
        inputMode: 'text',
      },
    ],
    PASSPORT: [
      {
        label: 'Passport Number',
        name: 'documentNumber',
        type: 'text',
        validators: [Validators.required],
        inputMode: 'text',
      },
      {
        label: 'Issue Date',
        name: 'issueDate',
        type: 'date',
        validators: [Validators.required],
        inputMode: 'text',
      },
    ],
    DRIVING_LICENSE: [
      {
        label: 'License Number',
        name: 'documentNumber',
        type: 'text',
        validators: [Validators.required],
        inputMode: 'text',
      },
      {
        label: 'Expiry Date',
        name: 'expiryDate',
        type: 'date',
        validators: [Validators.required],
        inputMode: 'text',
      },
    ],
  };
  

  getCloudStoragePath(doctype: DocumentEnum) {
    return this.restApiService.get(
      this.getDocument + this.getAllCloudStoragePath + '/' + doctype
    );
  }

  getDocumentById(docId: string) {
    return this.restApiService.get(this.getDocument + '/' + docId);
  }

  deleteDocumentById(docId: string) {
    return this.restApiService.delete(`${this.getDocument}/${docId}`);
  }

  uploadDocument(payload: any) {

    return this.restApiService.post(`${this.getDocument}`, payload);
  }
  updateDocument(payload: any,docId:string) {
  
    return this.restApiService.put(`${this.getDocument}/${docId}`, payload);
  }
  getUserDocuments(user_id: string) {
    return this.restApiService.get(`${this.getDocument}/user/${user_id}`, "json");
  }

  getCloudStorageFilePath(cloudStorageFolderName) {
    return this.restApiService.post(
      this.getDocument + '/user/getUserDocuments',
      cloudStorageFolderName
    );
  }

  triggerDocumentRefresh() {
    this.documentRefreshSource.next();
  }

  triggerMailToAllUsers(){
    return this.restApiService.get(this.getDocument+'/user/triggerDocumentMail'); 
  }

  triggerMailToSingleUser(userId:string){
    return this.restApiService.get(this.getDocument+`/user/userTriggerDocumentMail/${userId}`); 
  }
  triggerMailToSelectedUsers(users:string[]){
    return this.restApiService.post(this.getDocument+`/user/selectedUserTriggerDocumentMail`,users); 
  }

  getDocumentNumber(doctype:DocumentEnum)
  {
    return this.restApiService.get(this.getDocument+`/issueNumber/${doctype}`)
  }
}